export function normalizeTheme(value) {
  return value === 'dark' || value === 'light' ? value : ''
}

export function themeFromUrl(value) {
  try {
    const url = new URL(value, 'http://localhost')
    const direct = normalizeTheme(url.searchParams.get('theme'))
    if (direct) return direct

    const hashQuery = url.hash.includes('?')
      ? new URLSearchParams(url.hash.slice(url.hash.indexOf('?'))).get('theme')
      : null
    return normalizeTheme(hashQuery)
  } catch {
    return ''
  }
}

export function resolveTheme({
  urlTheme,
  injectedTheme,
  storedTheme,
  systemTheme,
} = {}) {
  return (
    normalizeTheme(urlTheme) ||
    normalizeTheme(injectedTheme) ||
    normalizeTheme(storedTheme) ||
    normalizeTheme(systemTheme) ||
    'light'
  )
}
